import axios, {isCancel} from 'axios';
import rateLimit from 'axios-rate-limit';

const instance = rateLimit(axios.create(), { maxRequests: 50, perMilliseconds: 4000 });

instance.defaults.headers.common['X-Requested-With2'] = 'XMLHttpRequest';

instance.interceptors.request.use(function (config) {
    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    return config;
});

instance.interceptors.response.use(
    (response) => {
        const serverBuildVersion = response.headers['x-edjin-version'];
        if(serverBuildVersion && window.buildVersion && window.buildVersion !== serverBuildVersion) {
            console.log('build version does not match', serverBuildVersion, window.buildVersion);
            //window.location.reload();
        }

        if(typeof globalReactFunctions.currentConcept !== 'undefined' && globalReactFunctions.currentConcept) {
            const conceptId = response.headers['x-concept-id'];
            const serverConceptId = globalReactFunctions.currentConcept.conceptId;

            if(conceptId && serverConceptId && conceptId != serverConceptId) {
                //window.location.reload();
            }
        }

        if(!response.request.responseURL.endsWith('/web/ui/user/public/sessionLastAccessedTime')) {
            sessionStorage.setItem('networkDate', Date.now());
        }

        return response;
    },
    (error) => {

        if (isCancel(error)) {
            // handles purposefully cancelled request on components unmounting before axios requests are completed.
            console.log('axios request cancel handled', error);
        }else if(error.response) {
            console.log('HTTP error', error.response.status);
            if (error.response.status === 401 || error.response.status === 403) {
                window.location = '/';
            } else if(error.response.status === 429) {
                displayToastMessage('You have acceded you request rate limit', '', 'error', undefined, 5000);
            } else if(error.response.status !== 422) {
                displayToastMessage('General network error, try again', '', 'error');
            }
        } else {
            displayToastMessage('General network error, try again', '', 'error');
        }

        return Promise.reject(error);
    }
);


/* Axios post request, put in the config section of the axios request
 {
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
}
*/
export const prepareAxiosParamsForStruts = (params)=>{
    const urlSearchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(params)){
        if(Array.isArray(value)){
            value.forEach((arrItem)=>{
                urlSearchParams.append(key,arrItem);
            })
        }else{
            urlSearchParams.append(key,value);
        }
    }
    return urlSearchParams;
}

export default instance;
